import {Component, HostListener, OnInit} from "@angular/core";
import {ProgressbarConfig} from "ngx-bootstrap/progressbar";
import {getProgressbarConfig} from "../enrollment/enrollment.component";
import {ApplicationsService} from "../../shared/services/applications.service";
import {ApplicationModel} from "../../shared/models/application.model";

@Component({
  selector: 'app-applications',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.scss'],
  providers: [{provide: ProgressbarConfig, useFactory: getProgressbarConfig}]
})
export class ApplicationsComponent implements OnInit {

  serviceProviderApplications: Array<ApplicationModel> = [];
  currentPage = 1;
  pageSize = 16;
  loading: boolean = false;
  endOfList: boolean = false;
  q = '';

  constructor(private applicationsService: ApplicationsService) {
  }

  ngOnInit(): void {
    this.loadApplications();
  }

  loadApplications() {
    if (this.loading || this.endOfList) {
      return;
    }
    this.loading = true;
    const page = Math.ceil(this.serviceProviderApplications.length / this.pageSize) + 1;

    this.applicationsService.getApplications(page, this.pageSize, this.q)
      .subscribe(
        resp => {
          if (resp.length === 0) {
            this.endOfList = true;
          } else {
            this.serviceProviderApplications = this.serviceProviderApplications.concat(resp);
          }
          this.loading = false;
        },
        error => {
          console.log(error);
          this.loading = false;
        }
      );
  }

  loadApplicationsFromSearch() {
    this.currentPage = 1;
    this.endOfList = false;
    this.serviceProviderApplications = [];
    this.loadApplications();
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const bodyHeight = document.body.scrollHeight;
    const scrollPercentage = (scrollPosition / (bodyHeight - windowHeight)) * 100;

    if (scrollPercentage > 80) {
      this.loadApplications();
    }
  }
}
